import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Alert from '../Alert.js'

export default class ChooseForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    courseId: PropTypes.string.isRequired,
    courses: PropTypes.array,
    formErrorMsg: PropTypes.string,
  }

  static defaultProps = {
    courses: [],
  }

  constructor(props) {
    super(props)

    this.state = {
      courseIdInput: props.courseId || -1,
      errorMsg: props.formErrorMsg,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let newState = {}
    if (this.props.formErrorMsg !== nextProps.formErrorMsg) {
      newState['errorMsg'] = nextProps.formErrorMsg
    }
    if (this.props.courseId !== nextProps.courseId) {
      newState['courseIdInput'] = nextProps.courseId
    }

    if (Object.keys(newState).length > 0) {
      this.setState(newState)
    }
  }

  postFormData = event => {
    event.preventDefault()
    let { courseId } = this.state

    if (courseId === -1 || courseId === '') {
      return this.setState({ errorMsg: 'You must select a course.' })
    }
    this.props.onSubmit(this.state.courseIdInput)
  }

  handleCourseIdChange = event => {
    this.setState({ courseIdInput: event.target.value })
  }

  generateSpinner = optionalClass => {
    return (
      <div className={classNames(optionalClass, 'spinner-holder')}>
        <div
          className="icon icon_spinner10 icon_spin2"
          style={{ fontSize: '50px' }}
        />
      </div>
    )
  }

  generateSelectField = () => {
    let courseOptions = this.props.courses.map(obj => (
      <option value={obj.id} key={obj.id}>
        {obj.name}
      </option>
    ))

    return (
      <select
        onChange={this.handleCourseIdChange}
        value={this.state.courseIdInput}
        className="form-control"
      >
        {courseOptions}
      </select>
    )
  }

  render() {
    let hasCanvasCourses = this.props.courses && this.props.courses.length !== 0
    let selectHtml = hasCanvasCourses
      ? this.generateSelectField(this.props.courses)
      : this.generateSpinner('main')

    let msg =
      this.props.formErrorMsg === '' ? null : (
        <Alert bootstrapClass="danger" message={this.props.formErrorMsg} />
      )

    return (
      <div>
        {msg}
        <form onSubmit={this.postFormData} className="canvas-settings-form">
          <label>
            <br />
            {selectHtml}
          </label>
          <br />
          <div className="form-control-wrapper">
            <button
              className="btn btn-primary btn-myed btn-primary-myed"
              type="submit"
            >
              Next <div className="fas fa-chevron-right ml-2" />
            </button>
          </div>
        </form>
      </div>
    )
  }
}
